import request from "./request";
import apis from "./apis";

const {
  mediaInfo,
  uploadMedia,
} = apis.media;

const media = {
  getMediaInfo: () => {
    return request.get(mediaInfo);
  },
  uploadMedia: (data: Object) => {
    return request.formJsonPost(uploadMedia, data);
  },
};

export default media;